import React from "react"

export type StatusBannerTone = "success" | "warning" | "error" | "info" | "neutral"

interface StatusBannerProps {
	tone: StatusBannerTone
	headline: string
	lines?: string[]
}

export function StatusBanner({tone, headline, lines = []}: StatusBannerProps) {
	return (
		<div className={`unit-status-banner ${tone}`} role="status">
			<strong className="status-banner-headline">{headline}</strong>
			{lines.map((line) => (
				<p key={line} className="status-banner-line">
					{line}
				</p>
			))}
		</div>
	)
}

export default StatusBanner
